export default [
  {
    "abbr": "AF",
    "name": "Afganistán"
  },
  {
    "abbr": "AL",
    "name": "Albania"
  },
  {
    "abbr": "DE",
    "name": "Alemania"
  },
  {
    "abbr": "DZ",
    "name": "Algeria"
  },
  {
    "abbr": "AD",
    "name": "Andorra"
  },
  {
    "abbr": "AO",
    "name": "Angola"
  },
  {
    "abbr": "AI",
    "name": "Anguila"
  },
  {
    "abbr": "AG",
    "name": "Antigua y Barbuda"
  },
  {
    "abbr": "AN",
    "name": "Antillas Neerlandesas"
  },
  {
    "abbr": "AQ",
    "name": "Antártida"
  },
  {
    "abbr": "SA",
    "name": "Arabia Saudita"
  },
  {
    "abbr": "AR",
    "name": "Argentina"
  },
  {
    "abbr": "AM",
    "name": "Armenia"
  },
  {
    "abbr": "AW",
    "name": "Aruba"
  },
  {
    "abbr": "AU",
    "name": "Australia"
  },
  {
    "abbr": "AT",
    "name": "Austria"
  },
  {
    "abbr": "AZ",
    "name": "Azerbayán"
  },
  {
    "abbr": "BS",
    "name": "Bahamas"
  },
  {
    "abbr": "BH",
    "name": "Bahrein"
  },
  {
    "abbr": "BD",
    "name": "Bangladesh"
  },
  {
    "abbr": "BB",
    "name": "Barbados"
  },
  {
    "abbr": "BZ",
    "name": "Belice"
  },
  {
    "abbr": "BJ",
    "name": "Benín"
  },
  {
    "abbr": "BT",
    "name": "Bhután"
  },
  {
    "abbr": "BY",
    "name": "Bielorrusia"
  },
  {
    "abbr": "MM",
    "name": "Birmania"
  },
  {
    "abbr": "BO",
    "name": "Bolivia"
  },
  {
    "abbr": "BA",
    "name": "Bosnia y Herzegovina"
  },
  {
    "abbr": "BW",
    "name": "Botsuana"
  },
  {
    "abbr": "BR",
    "name": "Brasil"
  },
  {
    "abbr": "BN",
    "name": "Brunéi"
  },
  {
    "abbr": "BG",
    "name": "Bulgaria"
  },
  {
    "abbr": "BF",
    "name": "Burkina Faso"
  },
  {
    "abbr": "BI",
    "name": "Burundi"
  },
  {
    "abbr": "BE",
    "name": "Bélgica"
  },
  {
    "abbr": "CV",
    "name": "Cabo Verde"
  },
  {
    "abbr": "KH",
    "name": "Camboya"
  },
  {
    "abbr": "CM",
    "name": "Camerún"
  },
  {
    "abbr": "CA",
    "name": "Canadá"
  },
  {
    "abbr": "TD",
    "name": "Chad"
  },
  {
    "abbr": "CL",
    "name": "Chile"
  },
  {
    "abbr": "CN",
    "name": "China"
  },
  {
    "abbr": "CY",
    "name": "Chipre"
  },
  {
    "abbr": "VA",
    "name": "Ciudad del Vaticano"
  },
  {
    "abbr": "CO",
    "name": "Colombia"
  },
  {
    "abbr": "KM",
    "name": "Comoras"
  },
  {
    "abbr": "CD",
    "name": "Congo"
  },
  {
    "abbr": "KP",
    "name": "Corea del Norte"
  },
  {
    "abbr": "KR",
    "name": "Corea del Sur"
  },
  {
    "abbr": "CR",
    "name": "Costa Rica"
  },
  {
    "abbr": "CI",
    "name": "Costa de Marfil"
  },
  {
    "abbr": "HR",
    "name": "Croacia"
  },
  {
    "abbr": "CU",
    "name": "Cuba"
  },
  {
    "abbr": "DK",
    "name": "Dinamarca"
  },
  {
    "abbr": "DM",
    "name": "Dominica"
  },
  {
    "abbr": "EC",
    "name": "Ecuador"
  },
  {
    "abbr": "EG",
    "name": "Egipto"
  },
  {
    "abbr": "SV",
    "name": "El Salvador"
  },
  {
    "abbr": "AE",
    "name": "Emiratos Árabes Unidos"
  },
  {
    "abbr": "ER",
    "name": "Eritrea"
  },
  {
    "abbr": "SK",
    "name": "Eslovaquia"
  },
  {
    "abbr": "SI",
    "name": "Eslovenia"
  },
  {
    "abbr": "ES",
    "name": "España"
  },
  {
    "abbr": "US",
    "name": "Estados Unidos de América"
  },
  {
    "abbr": "EE",
    "name": "Estonia"
  },
  {
    "abbr": "ET",
    "name": "Etiopía"
  },
  {
    "abbr": "PH",
    "name": "Filipinas"
  },
  {
    "abbr": "FI",
    "name": "Finlandia"
  },
  {
    "abbr": "FJ",
    "name": "Fiyi"
  },
  {
    "abbr": "FR",
    "name": "Francia"
  },
  {
    "abbr": "GA",
    "name": "Gabón"
  },
  {
    "abbr": "GM",
    "name": "Gambia"
  },
  {
    "abbr": "GE",
    "name": "Georgia"
  },
  {
    "abbr": "GH",
    "name": "Ghana"
  },
  {
    "abbr": "GI",
    "name": "Gibraltar"
  },
  {
    "abbr": "GD",
    "name": "Granada"
  },
  {
    "abbr": "GR",
    "name": "Grecia"
  },
  {
    "abbr": "GL",
    "name": "Groenlandia"
  },
  {
    "abbr": "GP",
    "name": "Guadalupe"
  },
  {
    "abbr": "GU",
    "name": "Guam"
  },
  {
    "abbr": "GT",
    "name": "Guatemala"
  },
  {
    "abbr": "GF",
    "name": "Guayana Francesa"
  },
  {
    "abbr": "GG",
    "name": "Guernsey"
  },
  {
    "abbr": "GN",
    "name": "Guinea"
  },
  {
    "abbr": "GQ",
    "name": "Guinea Ecuatorial"
  },
  {
    "abbr": "GW",
    "name": "Guinea-Bissau"
  },
  {
    "abbr": "GY",
    "name": "Guyana"
  },
  {
    "abbr": "HT",
    "name": "Haití"
  },
  {
    "abbr": "HN",
    "name": "Honduras"
  },
  {
    "abbr": "HK",
    "name": "Hong kong"
  },
  {
    "abbr": "HU",
    "name": "Hungría"
  },
  {
    "abbr": "IN",
    "name": "India"
  },
  {
    "abbr": "ID",
    "name": "Indonesia"
  },
  {
    "abbr": "IQ",
    "name": "Irak"
  },
  {
    "abbr": "IE",
    "name": "Irlanda"
  },
  {
    "abbr": "IR",
    "name": "Irán"
  },
  {
    "abbr": "BV",
    "name": "Isla Bouvet"
  },
  {
    "abbr": "NF",
    "name": "Isla Norfolk"
  },
  {
    "abbr": "IM",
    "name": "Isla de Man"
  },
  {
    "abbr": "CX",
    "name": "Isla de Navidad"
  },
  {
    "abbr": "IS",
    "name": "Islandia"
  },
  {
    "abbr": "BM",
    "name": "Islas Bermudas"
  },
  {
    "abbr": "KY",
    "name": "Islas Caimán"
  },
  {
    "abbr": "CC",
    "name": "Islas Cocos (Keeling)"
  },
  {
    "abbr": "CK",
    "name": "Islas Cook"
  },
  {
    "abbr": "FO",
    "name": "Islas Feroe"
  },
  {
    "abbr": "GS",
    "name": "Islas Georgias del Sur y Sandwich del Sur"
  },
  {
    "abbr": "HM",
    "name": "Islas Heard y McDonald"
  },
  {
    "abbr": "MV",
    "name": "Islas Maldivas"
  },
  {
    "abbr": "FK",
    "name": "Islas Malvinas"
  },
  {
    "abbr": "MP",
    "name": "Islas Marianas del Norte"
  },
  {
    "abbr": "MH",
    "name": "Islas Marshall"
  },
  {
    "abbr": "PN",
    "name": "Islas Pitcairn"
  },
  {
    "abbr": "SB",
    "name": "Islas Salomón"
  },
  {
    "abbr": "TC",
    "name": "Islas Turcas y Caicos"
  },
  {
    "abbr": "UM",
    "name": "Islas Ultramarinas Menores de Estados Unidos"
  },
  {
    "abbr": "VG",
    "name": "Islas Vírgenes Británicas"
  },
  {
    "abbr": "VI",
    "name": "Islas Vírgenes de los Estados Unidos"
  },
  {
    "abbr": "AX",
    "name": "Islas de Åland"
  },
  {
    "abbr": "IL",
    "name": "Israel"
  },
  {
    "abbr": "IT",
    "name": "Italia"
  },
  {
    "abbr": "JM",
    "name": "Jamaica"
  },
  {
    "abbr": "JP",
    "name": "Japón"
  },
  {
    "abbr": "JE",
    "name": "Jersey"
  },
  {
    "abbr": "JO",
    "name": "Jordania"
  },
  {
    "abbr": "KZ",
    "name": "Kazajistán"
  },
  {
    "abbr": "KE",
    "name": "Kenia"
  },
  {
    "abbr": "KG",
    "name": "Kirgizstán"
  },
  {
    "abbr": "KI",
    "name": "Kiribati"
  },
  {
    "abbr": "KW",
    "name": "Kuwait"
  },
  {
    "abbr": "LA",
    "name": "Laos"
  },
  {
    "abbr": "LS",
    "name": "Lesoto"
  },
  {
    "abbr": "LV",
    "name": "Letonia"
  },
  {
    "abbr": "LR",
    "name": "Liberia"
  },
  {
    "abbr": "LY",
    "name": "Libia"
  },
  {
    "abbr": "LI",
    "name": "Liechtenstein"
  },
  {
    "abbr": "LT",
    "name": "Lituania"
  },
  {
    "abbr": "LU",
    "name": "Luxemburgo"
  },
  {
    "abbr": "LB",
    "name": "Líbano"
  },
  {
    "abbr": "MO",
    "name": "Macao"
  },
  {
    "abbr": "MK",
    "name": "Macedônia"
  },
  {
    "abbr": "MG",
    "name": "Madagascar"
  },
  {
    "abbr": "MY",
    "name": "Malasia"
  },
  {
    "abbr": "MW",
    "name": "Malawi"
  },
  {
    "abbr": "ML",
    "name": "Mali"
  },
  {
    "abbr": "MT",
    "name": "Malta"
  },
  {
    "abbr": "MA",
    "name": "Marruecos"
  },
  {
    "abbr": "MQ",
    "name": "Martinica"
  },
  {
    "abbr": "MU",
    "name": "Mauricio"
  },
  {
    "abbr": "MR",
    "name": "Mauritania"
  },
  {
    "abbr": "YT",
    "name": "Mayotte"
  },
  {
    "abbr": "FM",
    "name": "Micronesia"
  },
  {
    "abbr": "MD",
    "name": "Moldavia"
  },
  {
    "abbr": "MN",
    "name": "Mongolia"
  },
  {
    "abbr": "ME",
    "name": "Montenegro"
  },
  {
    "abbr": "MS",
    "name": "Montserrat"
  },
  {
    "abbr": "MZ",
    "name": "Mozambique"
  },
  {
    "abbr": "MX",
    "name": "México"
  },
  {
    "abbr": "MC",
    "name": "Mónaco"
  },
  {
    "abbr": "NA",
    "name": "Namibia"
  },
  {
    "abbr": "NR",
    "name": "Nauru"
  },
  {
    "abbr": "NP",
    "name": "Nepal"
  },
  {
    "abbr": "NI",
    "name": "Nicaragua"
  },
  {
    "abbr": "NE",
    "name": "Niger"
  },
  {
    "abbr": "NG",
    "name": "Nigeria"
  },
  {
    "abbr": "NU",
    "name": "Niue"
  },
  {
    "abbr": "NO",
    "name": "Noruega"
  },
  {
    "abbr": "NC",
    "name": "Nueva Caledonia"
  },
  {
    "abbr": "NZ",
    "name": "Nueva Zelanda"
  },
  {
    "abbr": "OM",
    "name": "Omán"
  },
  {
    "abbr": "PK",
    "name": "Pakistán"
  },
  {
    "abbr": "PW",
    "name": "Palau"
  },
  {
    "abbr": "PS",
    "name": "Palestina"
  },
  {
    "abbr": "PA",
    "name": "Panamá"
  },
  {
    "abbr": "PG",
    "name": "Papúa Nueva Guinea"
  },
  {
    "abbr": "PY",
    "name": "Paraguay"
  },
  {
    "abbr": "NL",
    "name": "Países Bajos"
  },
  {
    "abbr": "PE",
    "name": "Perú"
  },
  {
    "abbr": "PF",
    "name": "Polinesia Francesa"
  },
  {
    "abbr": "PL",
    "name": "Polonia"
  },
  {
    "abbr": "PT",
    "name": "Portugal"
  },
  {
    "abbr": "PR",
    "name": "Puerto Rico"
  },
  {
    "abbr": "QA",
    "name": "Qatar"
  },
  {
    "abbr": "GB",
    "name": "Reino Unido"
  },
  {
    "abbr": "CF",
    "name": "República Centroafricana"
  },
  {
    "abbr": "CZ",
    "name": "República Checa"
  },
  {
    "abbr": "DO",
    "name": "República Dominicana"
  },
  {
    "abbr": "RE",
    "name": "Reunión"
  },
  {
    "abbr": "RW",
    "name": "Ruanda"
  },
  {
    "abbr": "RO",
    "name": "Rumanía"
  },
  {
    "abbr": "RU",
    "name": "Rusia"
  },
  {
    "abbr": "EH",
    "name": "Sahara Occidental"
  },
  {
    "abbr": "WS",
    "name": "Samoa"
  },
  {
    "abbr": "AS",
    "name": "Samoa Americana"
  },
  {
    "abbr": "BL",
    "name": "San Bartolomé"
  },
  {
    "abbr": "KN",
    "name": "San Cristóbal y Nieves"
  },
  {
    "abbr": "SM",
    "name": "San Marino"
  },
  {
    "abbr": "MF",
    "name": "San Martín (Francia)"
  },
  {
    "abbr": "PM",
    "name": "San Pedro y Miquelón"
  },
  {
    "abbr": "VC",
    "name": "San Vicente y las Granadinas"
  },
  {
    "abbr": "SH",
    "name": "Santa Elena"
  },
  {
    "abbr": "LC",
    "name": "Santa Lucía"
  },
  {
    "abbr": "ST",
    "name": "Santo Tomé y Príncipe"
  },
  {
    "abbr": "SN",
    "name": "Senegal"
  },
  {
    "abbr": "RS",
    "name": "Serbia"
  },
  {
    "abbr": "SC",
    "name": "Seychelles"
  },
  {
    "abbr": "SL",
    "name": "Sierra Leona"
  },
  {
    "abbr": "SG",
    "name": "Singapur"
  },
  {
    "abbr": "SY",
    "name": "Siria"
  },
  {
    "abbr": "SO",
    "name": "Somalia"
  },
  {
    "abbr": "LK",
    "name": "Sri lanka"
  },
  {
    "abbr": "ZA",
    "name": "Sudáfrica"
  },
  {
    "abbr": "SD",
    "name": "Sudán"
  },
  {
    "abbr": "SE",
    "name": "Suecia"
  },
  {
    "abbr": "CH",
    "name": "Suiza"
  },
  {
    "abbr": "SR",
    "name": "Surinám"
  },
  {
    "abbr": "SJ",
    "name": "Svalbard y Jan Mayen"
  },
  {
    "abbr": "SZ",
    "name": "Swazilandia"
  },
  {
    "abbr": "TJ",
    "name": "Tadjikistán"
  },
  {
    "abbr": "TH",
    "name": "Tailandia"
  },
  {
    "abbr": "TW",
    "name": "Taiwán"
  },
  {
    "abbr": "TZ",
    "name": "Tanzania"
  },
  {
    "abbr": "IO",
    "name": "Territorio Británico del Océano Índico"
  },
  {
    "abbr": "TF",
    "name": "Territorios Australes y Antárticas Franceses"
  },
  {
    "abbr": "TL",
    "name": "Timor Oriental"
  },
  {
    "abbr": "TG",
    "name": "Togo"
  },
  {
    "abbr": "TK",
    "name": "Tokelau"
  },
  {
    "abbr": "TO",
    "name": "Tonga"
  },
  {
    "abbr": "TT",
    "name": "Trinidad y Tobago"
  },
  {
    "abbr": "TN",
    "name": "Tunez"
  },
  {
    "abbr": "TM",
    "name": "Turkmenistán"
  },
  {
    "abbr": "TR",
    "name": "Turquía"
  },
  {
    "abbr": "TV",
    "name": "Tuvalu"
  },
  {
    "abbr": "UA",
    "name": "Ucrania"
  },
  {
    "abbr": "UG",
    "name": "Uganda"
  },
  {
    "abbr": "UY",
    "name": "Uruguay"
  },
  {
    "abbr": "UZ",
    "name": "Uzbekistán"
  },
  {
    "abbr": "VU",
    "name": "Vanuatu"
  },
  {
    "abbr": "VE",
    "name": "Venezuela"
  },
  {
    "abbr": "VN",
    "name": "Vietnam"
  },
  {
    "abbr": "WF",
    "name": "Wallis y Futuna"
  },
  {
    "abbr": "YE",
    "name": "Yemen"
  },
  {
    "abbr": "DJ",
    "name": "Yibuti"
  },
  {
    "abbr": "ZM",
    "name": "Zambia"
  },
  {
    "abbr": "ZW",
    "name": "Zimbabue"
  }
];
